module.exports = __webpack_public_path__ + "img/MotionSensor.787e692f.png";